import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';

const AdminDashboard = () => {
  const [restaurant, setRestaurant] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  useEffect(() => {
    const fetchRestaurantProfile = async () => {
      try {
        const token = localStorage.getItem('restaurantToken');
        
        // Check if token exists
        if (!token) {
          setError('Токен не найден. Пожалуйста, войдите снова.');
          setLoading(false);
          return;
        }
        
        const res = await axios.get('/api/auth/profile', {
          headers: {
            'x-auth-token': token
          }
        });
        setRestaurant(res.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching restaurant profile:', err);
        if (err.response) {
          // Server responded with error status
          setError(`Ошибка сервера: ${err.response.data.message || err.response.statusText}`);
        } else if (err.request) {
          // Request was made but no response received
          setError('Ошибка сети: Не удалось получить ответ от сервера');
        } else {
          // Something else happened
          setError(`Ошибка: ${err.message}`);
        }
        setLoading(false);
      }
    };
    
    fetchRestaurantProfile();
  }, []);
  
  if (loading) {
    return <div className="mt-5 text-center">Загрузка...</div>;
  }
  
  if (error) {
    return (
      <Container className="mt-5">
        <Row className="justify-content-center">
          <Col md={8}>
            <Alert variant="danger">
              <Alert.Heading>Ошибка загрузки профиля ресторана</Alert.Heading>
              <p>{error}</p>
              <Button 
                variant="primary" 
                onClick={() => {
                  localStorage.removeItem('restaurantToken');
                  window.location.href = '/login';
                }}
              >
                Войти снова
              </Button>
            </Alert>
          </Col>
        </Row>
      </Container>
    );
  }
  
  if (!restaurant) {
    return (
      <Container className="mt-5">
        <Row className="justify-content-center">
          <Col md={8}>
            <Alert variant="warning">
              <Alert.Heading>Профиль ресторана не найден</Alert.Heading>
              <p>Не удалось загрузить информацию о ресторане.</p>
              <Button 
                variant="primary" 
                onClick={() => {
                  localStorage.removeItem('restaurantToken');
                  window.location.href = '/login';
                }}
              >
                Войти снова
              </Button>
            </Alert>
          </Col>
        </Row>
      </Container>
    );
  }
  
  return (
    <Container className="mt-5">
      <Row className="mb-4">
        <Col>
          <h1>Панель управления</h1>
          <p>Добро пожаловать, {restaurant.name}! Управляйте меню и заказами вашего ресторана здесь.</p>
        </Col>
      </Row>
      
      <Row>
        <Col md={6} lg={6} className="mb-6">
          <Card>
            <Card.Body>
              <Card.Title>Управление меню</Card.Title>
              <Card.Text>
                Создавайте, обновляйте и управляйте пунктами меню вашего ресторана.
              </Card.Text>
              <Button as={Link} to="/admin/menu" variant="primary">Управление меню</Button>
            </Card.Body>
          </Card>
        </Col>
        
        <Col md={6} lg={6} className="mb-6">
          <Card>
            <Card.Body>
              <Card.Title>Управление заказами</Card.Title>
              <Card.Text>
                Просматривайте и управляйте заказами клиентов и платежами.
              </Card.Text>
              <Button as={Link} to="/admin/orders" variant="primary">Просмотр заказов</Button>
            </Card.Body>
          </Card>
        </Col>      
       </Row>
      
      <Row>
        <Col>
          <Card>
            <Card.Body>
              <Card.Title>Информация о ресторане</Card.Title>
              <p><strong>Название:</strong> {restaurant.restaurantName}</p>
              <p><strong>Описание:</strong> {restaurant.restaurantDescription || 'Описание не предоставлено'}</p>
              <p><strong>Email:</strong> {restaurant.email}</p>
              <p><strong>Телефон:</strong> {restaurant.phone}</p>
              <p><strong>Адрес:</strong> {restaurant.address.street}, {restaurant.address.city}, {restaurant.address.state} {restaurant.address.zipCode}</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AdminDashboard;